import React,{useEffect} from "react";
import { SetTracePageId } from "@ctrip/corp-cross-utils";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import SmsPage from "./SmsPage";

function App() {
    useEffect(() => {
      SetTracePageId("10650106626");
    }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sms/:id" element={<SmsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
